/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import {
  updateOrganizationConfigurationRequest,
  fetchOrganizationConfigurationRequest,
} from '@/reducers/asyncRequests/registry'
import { getOrganizationConfiguration } from '@/reducers/organizations'

import {
  fetchOrganizationConfiguration,
  updateOrganizationConfiguration,
} from '../../../../actions/organizations'

import AllowUseDeprecatedResources from './AllowUseDeprecatedResources'

import type { StateProps, DispatchProps, ConsumerProps } from './types'
import type { ReduxState, ThunkDispatch } from '@/types/redux'

const mapStateToProps = (state: ReduxState, { organizationId }: ConsumerProps) => ({
  organizationId,
  isAllowedToUseDeprecatedResources:
    getOrganizationConfiguration(state, organizationId)?.service_restrictions
      ?.can_use_deprecated_resources || false,
  fetchOrganizationConfigurationRequest: fetchOrganizationConfigurationRequest(
    state,
    organizationId,
  ),
  updateOrganizationConfigurationRequest: updateOrganizationConfigurationRequest(
    state,
    organizationId,
  ),
})

const mapDispatchToProps = (dispatch: ThunkDispatch, { organizationId }: ConsumerProps) => ({
  fetchOrganizationConfiguration: () =>
    dispatch(fetchOrganizationConfiguration({ organizationId })),
  setAllowToUseDeprecatedResources: (newValue: boolean) =>
    dispatch(
      updateOrganizationConfiguration({
        organizationId,
        updateRequest: { service_restrictions: { can_use_deprecated_resources: newValue } },
      }),
    ),
})

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(AllowUseDeprecatedResources)
